import { Button, TextField } from "@material-ui/core";
import { useState } from "react";
import { useHistory } from "react-router";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import axios from "axios";
import "./Login.css";

const Home = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const history = useHistory();

  if (localStorage.getItem('token')) {
    history.push("/admin");
  }

  const handleSubmit = async () => {
    if (!username || !password) {
      setError(true);
      setErrorMsg('Please fill all the fields')
      return;
    } else {
      setError(false);
      try {
        const { data } = await axios.post(`https://computer-quiz-backend.herokuapp.com/login`,
        {
          username,
          password
        }
      );
        localStorage.setItem('token', data);
        history.push("/admin");
      } catch (error) {
        setError(true);
        setErrorMsg(error?.response?.data);
      }
    }
  };

  return (
    <div className="content">
      <div className="settings">
        <span style={{ fontSize: 30 }}>Administrator Login</span>
        <div className="settings__select">
          { error && <ErrorMessage>{errorMsg}</ErrorMessage> }
          <TextField
            style={{ marginBottom: 25 }}
            label="Enter Username"
            variant="outlined"
            onChange={(e) => setUsername(e?.target?.value)}
          />
           <TextField
            id="outlined-password-input"
            label="Enter Password"
            type="password"
            autoComplete="current-password"
            variant="outlined"
            onChange={(e) => setPassword(e?.target?.value)}
            />
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleSubmit}
          >
            Login
          </Button>
        </div>
      </div>
      <img src="/image.png" className="banner" alt="quiz app" />
    </div>
  );
};

export default Home;
